import { cn } from '@Utils/cn';

export interface StageTriggerCardProps {
  type: string;
  message: string;
  timestamp: string;
  className?: string;
}

export function StageTriggerCard({
  type,
  message,
  timestamp,
  className,
}: StageTriggerCardProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start rounded-lg border border-zinc-200 bg-zinc-50 p-3',
        className,
      )}
    >
      <p className="text-sm font-semibold leading-5 text-zinc-500">{type}</p>
      <p className="text-base leading-6 font-normal text-black">{message}</p>
      <p className="text-xs leading-4 font-normal text-zinc-400">
        {timestamp}
      </p>
    </div>
  );
}
